import { ConfigProvider } from "antd";
import styled from "styled-components";
import { HEADER_HEIGHT } from "../../constants";

export const PanelContent = ({
  children,
  disableScroll,
}: {
  children: React.ReactNode;
  disableScroll?: boolean;
}) => {
  return (
    // smaller texts to fit
    <ConfigProvider
      theme={{
        components: {
          Typography: {
            fontSize: 12,
          },
          Checkbox: {
            fontSize: 12,
          },
          Radio: {
            fontSize: 12,
          },
          Switch: {
            fontSize: 12,
          },
          ColorPicker: {
            fontSize: 12,
          },
        },
      }}
    >
      <StyledWrapper $disableScroll={disableScroll}>{children}</StyledWrapper>
    </ConfigProvider>
  );
};

const StyledWrapper = styled.div<{ $disableScroll?: boolean }>`
  height: calc(100vh - ${HEADER_HEIGHT}px);
  display: flex;
  flex-direction: column;

  /* remove antd tab padding */
  margin-left: -24px;

  /* hide last section border (direct children only, so panels nested inside
     wrappers like SettingsDisabledOverlay keep their divider) */
  & > section:last-child {
    border-bottom: none;
  }

  /* scrollable (unless disabled for tabs with internal scroll) */
  overflow: ${({ $disableScroll }) => ($disableScroll ? "hidden" : "auto")};

  overflow-x: visible;
`;
